export default "__VITE_ASSET__88f1aab4__"